import {Box} from "@mui/system"
import listingHero from "../../../images/listings/listing_hero_background.png"
import {ResponsiveRow} from "../../../constants/layout.constants"
import {Typography} from "@mui/material"
import Location from "@mui/icons-material/LocationOn"
import Straighten from "@mui/icons-material/Straighten"
import { formatCurrency, hasValidImages } from "../../../util/util"
import { useEffect, useState } from "react";
import { GET_LISTING_IMAGE_URL } from "../../../constants/url.constants"
import placeholderImage from "../../../images/building-placeholder.png"

export default function RecommendedListing({listing, handleView}) {
    const images = listing?.imageFiles && listing.imageFiles.length > 0 ? listing.imageFiles : [listingHero];
    const [currentImage, setCurrentImage] = useState(0);

    useEffect(() => {
        if (images.length <= 1) return;
        const interval = setInterval(() => {
            setCurrentImage((prev) => (prev + 1) % images.length || 0);
        }, 10000);
        return () => clearInterval(interval);
    }, [images.length]);

    return (
        <ResponsiveRow
            onClick={() => handleView(listing)}
            sx={{
                width: {xs: "100%", sm: "45%", md: "30%", lg: "23%"},
                minWidth: {xs: "100%", sm: "45%", md: "30%", lg: "23%"},
                cursor: "pointer",
                height: "375px",
                borderRadius: "20px",
                alignItems: "flex-start",
                backgroundColor: "#fff",
                padding: 0,
                margin: "10px 5px",
                "&:hover": {
                    transform: "scale(1.1)",
                    transitionDuration: "ease-in-out 700ms",
                },
            }}
        >
            <Box
                component="img"
                src={
                    hasValidImages(listing)
                        ? GET_LISTING_IMAGE_URL + "?filename=" + listing.imageFiles[currentImage]?.systemFileName
                        : placeholderImage
                }
                alt={hasValidImages(listing) ? "Property image" : "No image available"}
                sx={{
                    width: "100%",
                    height: "175px",
                    objectFit: "cover",
                    borderRadius: "20px 20px 0 0",
                }}
            />
            <ResponsiveRow
                sx={{
                    flexDirection: "column",
                    flexWrap: "nowrap",
                    width: "100%",
                    height: "40%",
                    textAlign: "start",
                    padding: "10px 20px",
                }}
            >
                <Typography
                    variant="body2"
                    sx={{color: "#afafaf", fontWeight: 600, marginBottom: "5px"}}
                >
                    Ksh {formatCurrency(listing?.price)}
                </Typography>

                <ResponsiveRow sx={{
                    flexDirection: "row", 
                    flexWrap: "nowrap", 
                    justifyContent: "space-between", 
                    alignItems: "center"
                }}>
                <Typography variant="h4" sx={{fontWeight: 700, marginBottom: "10px"}}>
                    {listing?.propertyName}
                </Typography>
                <Box
                    variant="contained"
                    sx={{
                        fontSize: "1rem",
                        marginBottom: "10px",
                        textTransform: "none",
                        backgroundColor: "#00B9AE",
                        color: "white",
                        fontWeight: 600,
                        padding: "5px 10px",
                        borderRadius: "10px",
                        width: "fit-content",
                    }}
                >
                    {listing.listingTypeCd ? listing.listingTypeCd.toUpperCase() : "LISTING TYPE NOT AVAILABLE"}
                </Box>
                </ResponsiveRow>
                <Typography
                    variant="body2"
                    sx={{marginBottom: "5px", color: "#00B9AE", display: "flex"}}
                >
                    <Location sx={{fontSize: "1.2rem"}}/> 
                    {listing.plusCode ? (
                        <a
                            target={"_blank"}
                            rel="noreferrer"
                            title={"View on Map"}
                            href={
                                "https://www.google.com.sa/maps/search/" +
                                encodeURIComponent(listing.plusCode) +
                                "?hl=en"
                            }
                        >
                            <span
                                style={{
                                    display: "flex",
                                    flexWrap: "wrap",
                                }}
                            >
                                {listing.plusCode}
                            </span>
                        </a>
                    ) : (
                        "No Location Info"
                    )}
                </Typography>
                <Typography sx={{fontSize: "1rem", marginBottom: "10px"}}>
                    <Straighten sx={{fontSize: "1.2rem"}}/> {formatCurrency(listing?.sqft)} SqM
                </Typography>
            </ResponsiveRow>
        </ResponsiveRow>
    )
}
